import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'app/helpers/routing';
import { FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import AccessibleTextField from 'app/components/deprecated/shared/AccessibleTextField';
import { ModalHeader, ModalContent, ModalFooter } from 'app/components/shared/Modal';
import { savedSearchShape } from 'app/shapes/search';

export class SavedSearchModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      duplicate: false,
      name: this.props.router.query.query
    };
    bindAll(this);
  }

  static getDerivedStateFromProps(props) {
    return props.savedSearch.get('isDuplicate') ? { duplicate: true } : null;
  }

  handleChange(name) {
    this.setState({ name });
  }

  handlePrimaryAction() {
    const { duplicate, name } = this.state;
    const { savedSearchActions } = this.props;
    const query = window.location.search;

    const saveAction = duplicate ? savedSearchActions.replaceSearch : savedSearchActions.saveSearch;

    return saveAction({
      name,
      query,
      postSuccess: () => {
        this.props.handleClose();
      }
    });
  }

  render() {
    const { savedSearch } = this.props;
    const { duplicate, name } = this.state;

    const modalTitle = duplicate ? (
      <FormattedMessage id="save_search_confirm" />
    ) : (
      <FormattedMessage id="save_search" />
    );
    const primaryButtonText = duplicate ? (
      <FormattedMessage id="button_confirm" />
    ) : (
      <FormattedMessage id="button_save" />
    );

    const lastNameAttempt = savedSearch.get('lastNameAttempt');
    const fieldErrors = savedSearch.get('fieldErrors');
    const isSaving = savedSearch.get('isSaving', false);

    return (
      <div className="cp-saved-search-modal">
        <ModalHeader title={modalTitle} />
        <ModalContent>
          {!duplicate ? (
            <div className="new-save-search">
              <label id="search-name-label" htmlFor="search-name" className="search-name-label">
                <FormattedMessage id="save_search_label" />
              </label>
              <AccessibleTextField
                type="text"
                id="search-name"
                maxLength={100}
                required
                handleChange={this.handleChange}
                value={name}
                className="form-control search-name-field"
                labelledById="search-name-label"
                fieldErrors={fieldErrors}
              />
            </div>
          ) : (
            <div className="saved-search-duplicate-prompt">
              <FormattedMessage
                id="save_search_duplicate_prompt"
                values={{ search_name: <strong>{lastNameAttempt}</strong> }}
              />
            </div>
          )}
        </ModalContent>
        <ModalFooter
          primaryActionButtonText={primaryButtonText}
          handlePrimaryAction={this.handlePrimaryAction}
          isLoading={isSaving}
        />
      </div>
    );
  }
}

SavedSearchModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  savedSearch: savedSearchShape.isRequired,
  savedSearchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(SavedSearchModal);
